<template>
  <div>
    <div class="rounded-box mb-2 p-3" v-html="$t('try-refresh')"></div>
    <hr class="mb-4 mt-4 w-100">
    <div><a href="https://www.opensalud.es/es/Home/FaqAppRequisitosIncidencias" target="_blank"><b-icon-info-circle class="mr-2"></b-icon-info-circle>{{ $t('faq') }}</a></div>
    <hr class="mb-4 mt-4 w-100">
    <div id="support-chat">
      <div class="mb-3 clickable" @click="$helpers.openSupportChat()"><b-icon-chat class="mr-2"></b-icon-chat><span v-html="$t('chat-attention')"></span></div>
    </div>
  </div>
</template>

<script>
import { BIcon, BIconInfoCircle, BIconChat } from 'bootstrap-vue'
import LoadingAnim from '@/components/utils/LoadingAnim'
import HubspotChat from '@/components/public/HubspotChat'

export default {
  components: {
    BIcon,
    BIconInfoCircle,
    BIconChat,
    'loading-anim': LoadingAnim,
    'hubspot-chat': HubspotChat
  }
}
</script>

<style lang="less">
  .rounded-box {
    background-color: #333c4f47;
    color: #292929;
    border-radius: 5px;
    font-size: 18px;
  }
</style>


// WEBPACK FOOTER //
// src/components/video-launcher/HelpSection.vue